module.exports = __webpack_public_path__ + "media/images/front/icon_review_yj_l-a7a214eac66c72adf299ecd70be7deea.png";